import { render, staticRenderFns } from "./IcoDocsDrafts.vue?vue&type=template&id=56d55233"
import script from "./IcoDocsDrafts.vue?vue&type=script&lang=js"
export * from "./IcoDocsDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports